import React from 'react';
import './SalesOverviewCard.css';
import { ChartLineUp } from 'phosphor-react';
import { formatCurrency, formatNumber } from '../utilities/formatCurrency';

const SalesOverviewCard = ({ totalSales, totalTests, totalAmount, isLoading = true }) => {
 
  return (
    <div className="sales-overview-card">
       <div className="top-right-icon" style={{ background: 'linear-gradient(135deg, rgba(99,102,241,0.12), rgba(139,92,246,0.1))' }}>
        <ChartLineUp size={22} weight="bold" className="sales-icon" style={{ color: '#6366f1' }} />
      </div>
      <div className="main-content">
        <div className="title">Total Revenue</div>
        <div className="value">
          {isLoading ? <span className="skeleton skeleton-text lg" /> : formatCurrency(totalAmount.toFixed(2))}
        </div>
      </div>
      <div className="sub-content-container">
        <div className="sub-content-item">
          <div className="sub-title">Sales</div>
          <div className="sub-value">{isLoading ? <span className="skeleton skeleton-text lg" /> : formatNumber(Number(totalSales))}</div>
        </div>
        <div className="sub-content-item">
          <div className="sub-title">Tests</div>
          <div className="sub-value">{isLoading ? <span className="skeleton skeleton-text lg" /> : formatNumber(totalTests)}</div>
        </div>
      </div>
    </div>
  );
};

export default SalesOverviewCard;
